import {ReadApiCall} from '../../reader/message/ReadApiCall';

export class TableToApiConfiguration extends ReadApiCall {
chunkSize: number | null;
exitStatusOnNoObtainedData: boolean | null;
exitStatusOnNoResponseData: boolean | null;
fieldName: string;
readKind: string;
responseFieldName: string;
responseTableName: string;
rootFieldName: string;
tableName: string;
truncateResponseTable: boolean | null;
useProcessUuid: boolean | null;
waitTimeBeforeApiCallRepeat: number;
}

